/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_water_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pale-yellow urine and infrequent thirst are good everyday signs. Needs rise in heat, at altitude and during illness.`)
};

const es_water_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una orina de color amarillo pálido y sed poco frecuente son buenas señales cotidianas. Las necesidades aumentan con el calor, la altitud y las enfermedades.`)
};

const de_water_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hellgelber Urin und selten auftretender Durst sind im Alltag gute Anzeichen. Der Bedarf steigt bei Hitze, in großer Höhe und während einer Krankheit.`)
};

const nl_water_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lichtgele urine en zelden dorst zijn goede dagelijkse signalen. De behoefte stijgt bij hitte, op hoogte en tijdens ziekte.`)
};

const fr_water_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une urine jaune pâle et une soif peu fréquente sont de bons signes au quotidien. Les besoins augmentent avec la chaleur, l'altitude et la maladie.`)
};

const it_water_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un'urina giallo pallido e una sete poco frequente sono buoni segnali quotidiani. Il fabbisogno aumenta con il caldo, in alta quota e durante le malattie.`)
};

const pt_br2_water_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urina de cor amarelo-clara e sede pouco frequente são bons sinais do dia a dia. A necessidade aumenta com calor, altitude e durante doenças.`)
};

const pt_water_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma urina amarelo-clara e sede pouco frequente são bons sinais do dia a dia. As necessidades aumentam com o calor, em altitude e durante a doença.`)
};

const ja_water_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尿の色が薄い黄色であることや、喉の渇きをあまり感じないことが日常的な良い指標です。暑さ、高地、体調不良時は必要量が増えます。`)
};

const zh_water_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尿液呈淡黄色、且不常感到口渴是良好的日常信号。在炎热天气、高海拔或生病时，需水量会增加。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const water_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.water_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("water_faq_a4", locale)
	if (locale === "en") return en_water_faq_a4(inputs)
	if (locale === "es") return es_water_faq_a4(inputs)
	if (locale === "de") return de_water_faq_a4(inputs)
	if (locale === "nl") return nl_water_faq_a4(inputs)
	if (locale === "fr") return fr_water_faq_a4(inputs)
	if (locale === "it") return it_water_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_water_faq_a4(inputs)
	if (locale === "pt") return pt_water_faq_a4(inputs)
	if (locale === "ja") return ja_water_faq_a4(inputs)
	return zh_water_faq_a4(inputs)
};